// @core/api/endpoints/booking/delete_booking_numbering_scheme.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/booking';

/**
 * Delete numbering scheme
 * Deletes a booking numbering scheme. Existing booking numbers are not affected.
 */
export async function DeleteBookingNumberingScheme(
  scheme_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/booking-numbering-schemes/:scheme_id`;
  requestPath = requestPath.replace(':scheme_id', encodeURIComponent(scheme_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
